module.exports = __webpack_public_path__ + "static/media/setting.e33c3b06.png";